import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
  dialogPaper: { borderRadius: 14, boxShadow: "0 18px 60px rgba(16,24,40,0.18)", overflow: "hidden" },
  dialogTitle: { padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" },
  titleWrapper: { display: "flex", flexDirection: "column", gap: 2 },
  title: { fontSize: 16, fontWeight: 600, fontFamily: "Inter, system-ui, sans-serif", color: "#111827" },
  subtitle: { fontSize: 12.5, color: "#6B7280" },
  closeButton: { width: 36, height: 36, borderRadius: 10, border: "1px solid rgba(17,24,39,0.08)" },
  dialogContent: {
    padding: 20,
    background: "linear-gradient(180deg, rgba(249,250,251,0.6) 0%, rgba(255,255,255,1) 100%)",
    "& .MuiOutlinedInput-root": { borderRadius: 12, backgroundColor: "#fff" }
  },
  dialogActions: { padding: "14px 20px", borderTop: "1px solid rgba(17,24,39,0.06)", gap: 10 },
  primaryButton: { borderRadius: 12, textTransform: "none" },
  secondaryButton: { borderRadius: 12, textTransform: "none" },
}));

const FlowBuilderAddEmailModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);
  const [activeModal, setActiveModal] = useState(false);
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [labels, setLabels] = useState({ title: "Enviar Email", btn: "Adicionar" });

  useEffect(() => {
    if (open === "edit") {
      setLabels({ title: "Editar Email", btn: "Salvar" });
      setTo(data?.data?.to || "");
      setSubject(data?.data?.subject || "");
      setBody(data?.data?.body || "");
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({ title: "Enviar Email", btn: "Adicionar" });
      setTo(""); setSubject(""); setBody("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open, data]);

  useEffect(() => () => { isMounted.current = false; }, []);

  const handleSave = () => {
    const nodeData = { to, subject, body };
    if (open === "edit") {
      onUpdate({ ...data, data: { ...data.data, ...nodeData } });
    } else {
      onSave(nodeData);
    }
    close(null);
  };

  return (
    <Dialog open={activeModal} onClose={() => close(null)} maxWidth="sm" fullWidth classes={{ paper: classes.dialogPaper }}>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <div className={classes.titleWrapper}>
          <Typography className={classes.title}>{labels.title}</Typography>
          <Typography className={classes.subtitle}>Configure o email a ser enviado no fluxo</Typography>
        </div>
        <IconButton size="small" onClick={() => close(null)} className={classes.closeButton}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <TextField label="Para (destinatario)" variant="outlined" fullWidth value={to}
          onChange={e => setTo(e.target.value)}
          placeholder="{{buyer_email}} ou email@exemplo.com"
          helperText="Use {{buyer_email}} para enviar ao comprador da Hotmart"
          style={{ marginBottom: 16 }} />
        <TextField label="Assunto" variant="outlined" fullWidth value={subject}
          onChange={e => setSubject(e.target.value)}
          placeholder="Bem-vindo! Seu acesso esta pronto"
          style={{ marginBottom: 16 }} />
        <TextField label="Corpo do email" variant="outlined" fullWidth multiline rows={6} value={body}
          onChange={e => setBody(e.target.value)}
          placeholder="Ola {{buyer_name}}, seu acesso foi liberado!" />
        <Typography style={{ fontSize: 11, color: "#9ca3af", marginTop: 6 }}>
          Variaveis: buyer_email, buyer_name, product_name, purchase_date
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={() => close(null)} variant="outlined" className={classes.secondaryButton}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained" color="primary" className={classes.primaryButton} disabled={!to || !subject}>{labels.btn}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAddEmailModal;
